import { CheckRounded } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  TextField,
  Typography as T,
} from "@mui/material";
import { Trash2 } from "lucide-react";

type SaveState = "idle" | "saving" | "saved";

interface SamplePromptRowProps {
  index: number;
  value: string;
  saveState: SaveState;
  disabled?: boolean;
  onChange: (value: string) => void;
  onDelete: () => void;
}

const SamplePromptRow = ({
  index,
  value,
  saveState,
  disabled,
  onChange,
  onDelete,
}: SamplePromptRowProps) => {
  return (
    <Stack direction="row" gap={1} alignItems="flex-start">
      <Box flex={1}>
        <Stack direction="row" alignItems="center" gap={1} mb={0.5}>
          <T fontSize={13} fontWeight={600}>
            Prompt {index + 1}
          </T>
          {saveState === "saving" && <CircularProgress size={14} />}
          {saveState === "saved" && <CheckRounded sx={{ fontSize: 16 }} color="success" />}
        </Stack>
        <TextField
          fullWidth
          multiline
          minRows={2}
          placeholder="Enter a question or task"
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          inputProps={{ maxLength: 300 }}
          size="small"
        />
      </Box>
      <IconButton onClick={onDelete} disabled={disabled} size="small" sx={{ mt: 3 }}>
        <Trash2 size={18} />
      </IconButton>
    </Stack>
  );
};

export default SamplePromptRow;
